import { Component } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[gbc-table-cell]',
    templateUrl: './table-cell.component.html',
    styleUrls: ['./table-cell.component.scss'],
})
export class TableCellComponent {
  constructor() {}
}
